import { render, staticRenderFns } from "./MainSearch.vue?vue&type=template&id=530ec984"
import script from "./MainSearch.vue?vue&type=script&lang=js"
export * from "./MainSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports